import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
export const bus = new Vue();
// add filters
import filters from './global/filters/filters'
//materialdesignicons
import '@mdi/font/css/materialdesignicons.css'
//custom css
import './assets/css/variables.scss'
import './assets/css/custom.css'
//number formate
//https://www.npmjs.com/package/vue-filter-number-format
import numeral from 'numeral';
import numFormat from 'vue-filter-number-format';
//end
import VueApexCharts from 'vue-apexcharts'
//modules

import { registerModules } from "./register-modules";
import DashBoardModeule from "./modules/DashBoard";
import UploaddataModeule from "./modules/UploadData";
//import SummaryModeule from "./modules/Summary";
import ModelDataPreparation from "./modules/ModelDataPreparation";
import DashBoardModeuleTest from "./modules/DashBoardTest";
import EdaAnaysis from "./modules/EdaAnalysis";
import ViewModelData from "./modules/ModelData";
// plugins

import VueSweetalert2 from "./plugins/sweetalert";
// end plugins
//Vuetify
import Vuetify from 'vuetify/lib'
import 'vuetify/dist/vuetify.min.css'
const vuetifyOptions = {
  theme: {
      themes: {
          light: {
              primary: "#292961",
              secondary: "#3cbd9c",
              manuBackground: '#F3F5F8',
              titleText: '#505D6F',
              menuActive: '#51A7F8',
              blue: '#51A7F8',
              darkGrey: '#9AA1A9',
              secondaryButton: '#d8e7f5'
          }
      }
  },
}




registerModules({

  DashBoardModeule:DashBoardModeule,
  UploaddataModeule:UploaddataModeule,
  //SummaryModeule:SummaryModeule,
  ModelDataPreparation:ModelDataPreparation,
  DashBoardModeuleTest:DashBoardModeuleTest,
  EdaAnaysis:EdaAnaysis,
  ViewModelData:ViewModelData,
});

Vue.config.productionTip = false
Vue.filter('numFormat', numFormat(numeral));
Vue.use(Vuetify)
Vue.use(VueApexCharts)
new Vue({
  router,
  store,
  vuetify: new Vuetify(vuetifyOptions),
  VueSweetalert2,
  filters,
  VueApexCharts,
  render: h => h(App)
}).$mount("#app");
